import { BaseModel, attr } from "../../lib/itn-ui-kit/data";

export default class FieldOptionModel extends BaseModel {
  static urlPath = "field_options";

  @attr("string") key;
  @attr("string") label;
  @attr("string") value;
  @attr("string") contentType;
  @attr("string") fieldName;
  @attr("json") additionalAttributes;
}
